import { useMemo } from 'react';
import { prop } from 'ramda';
import { TFormField } from 'js/components/common/Form/types';
import { FORM_FIELD_TYPE, FORM_VALIDATION_RULE_TYPE } from 'js/components/common/Form/constants';

import { useDynamicReducerSelector } from '../../../store';

export const useLinkedPasswordFields = (fieldName: string) => {
    const fields = useDynamicReducerSelector(prop('fields'));

   return useMemo(() => fields.reduce((acc: string[], formField: TFormField) => {
       const { type, validation, validationRules } = formField;

       const excludePasswordFields = type === FORM_FIELD_TYPE.PASSWORD
           && validation
           && validationRules.find(rule => rule.type === FORM_VALIDATION_RULE_TYPE.exclusion)?.exclusionFields || [];

       if (excludePasswordFields.includes(fieldName)) {
           acc.push(formField.name);
       }

       return acc;
   }, []), [fields, fieldName]);
};
